module.exports = __webpack_public_path__ + "static/img/20180414165815.15139bd3.jpg";